import React, { Component } from 'react';
import Sound from 'react-sound';
class getMusic extends Component {

  togglePlay() {
    /*this.setState({ play: !this.state.play });
    console.log(this.audio);
    this.state.play ? this.audio.play() : this.audio.pause();*/
  }
  handleSongLoading =()=>{
    //console.log("handleSongLoading"+Sound.status.PLAYING)
  }
  handleSongPlaying =()=>{
    //console.log("handleSongPlaying"+Sound.status.PLAYING)
  }
  handleSongFinishedPlaying =()=>{
      //console.log("handleSongFinishedPlaying"+Sound.status.PLAYING)
  }
  render() {
      /*return (
      <div>
      <button onClick={this.togglePlay}>{this.state.play ? "Pause" : "Play"}</button>
      </div>
    )*/

    return (
      <React.Fragment>
        <Sound
          url={require('../image/campana_13.mp3')}
          playStatus={Sound.status.PLAYING}
          playFromPosition={0 /* in milliseconds */}
          onLoading={this.handleSongLoading}
          onPlaying={this.handleSongPlaying}
          onFinishedPlaying={this.handleSongFinishedPlaying}
          loop ={false}
          volume ={100}
        />
      </React.Fragment>

    )
  }
}

export default getMusic;
